(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-template"]) return;
  try {
    
  document.querySelectorAll('.accordion-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      document.querySelectorAll('.accordion-toggle').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
      document.querySelectorAll('.accordion-panel').forEach(function (panel) {
        panel.style.display = 'none';
      });
      if (!expanded) {
        btn.setAttribute('aria-expanded', 'true');
        btn.nextElementSibling.style.display = 'block';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-need"] && !Shopify.designMode) return;
  try {
    
  // document.addEventListener('DOMContentLoaded', function () {
    let currentIndex = 0;
    const track = document.getElementById('carouselTrack');
    const items = document.querySelectorAll('.carousel-item');
    const totalItems = items.length;
    let itemsPerView = 4;
    let isTransitioning = false;

    // Clone items for infinite loop
    function setupInfiniteLoop() {
      // Remove existing clones if any
      const existingClones = track.querySelectorAll('.clone');
      existingClones.forEach((clone) => clone.remove());

      // Clone enough items to fill the view on both sides
      const itemsToClone = Math.max(itemsPerView, 2);

      // Clone first items and append to end
      for (let i = 0; i < itemsToClone; i++) {
        const clone = items[i].cloneNode(true);
        clone.classList.add('clone');
        track.appendChild(clone);
      }

      // Clone last items and prepend to start
      for (let i = totalItems - 1; i >= totalItems - itemsToClone; i--) {
        const clone = items[i].cloneNode(true);
        clone.classList.add('clone');
        track.insertBefore(clone, track.firstChild);
      }

      // Set initial position (accounting for prepended clones)
      currentIndex = itemsToClone;
      track.style.transition = 'none';
      updateCarousel();
      setTimeout(() => {
        track.style.transition = 'transform 0.5s ease';
      }, 50);
    }

    function updateItemsPerView() {
      if (window.innerWidth <= 480) {
        itemsPerView = 1;
      } else if (window.innerWidth <= 768) {
        itemsPerView = 2;
      } else if (window.innerWidth <= 1200) {
        itemsPerView = 3;
      } else {
        itemsPerView = 4;
      }
    }

    function createIndicators() {
      const indicatorsContainer = document.getElementById('indicators');
      indicatorsContainer.innerHTML = '';

      for (let i = 0; i < totalItems; i++) {
        const indicator = document.createElement('button');
        indicator.classList.add('indicator');
        indicator.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        if (i === 0) {
          indicator.classList.add('active');
          indicator.setAttribute('aria-current', 'true');
        }
        indicator.onclick = () => goToSlide(i);
        indicatorsContainer.appendChild(indicator);
      }
    }

    function updateCarousel() {
      const itemWidth = 100 / itemsPerView;
      const offset = -currentIndex * itemWidth;
      track.style.transform = `translateX(${offset}%)`;

      updateIndicators();
      updateItemVisibility();
    }

    function updateItemVisibility() {
      const allItems = track.querySelectorAll('.carousel-item');
      const itemsToClone = Math.max(itemsPerView, 2);

      allItems.forEach((item, index) => {
        // Check if item is in the current view
        const isInView = index >= currentIndex && index < currentIndex + itemsPerView;

        if (isInView) {
          item.classList.remove('out-of-view');
        } else {
          item.classList.add('out-of-view');
        }
      });
    }

    function updateIndicators() {
      const indicators = document.querySelectorAll('.indicator');
      const itemsToClone = Math.max(itemsPerView, 2);
      let actualIndex = currentIndex - itemsToClone;

      // Handle wrapping for indicators
      if (actualIndex < 0) {
        actualIndex = totalItems + actualIndex;
      } else if (actualIndex >= totalItems) {
        actualIndex = actualIndex - totalItems;
      }

      indicators.forEach((indicator, index) => {
        const isActive = index === actualIndex;
        indicator.classList.toggle('active', isActive);
        if (isActive) {
          indicator.setAttribute('aria-current', 'true');
        } else {
          indicator.removeAttribute('aria-current');
        }
      });
    }

    function moveCarousel(direction) {
      if (isTransitioning) return;

      isTransitioning = true;
      currentIndex += direction;
      updateCarousel();

      setTimeout(() => {
        const itemsToClone = Math.max(itemsPerView, 2);
        const allItems = track.children.length;

        // Check if we need to jump
        if (currentIndex <= itemsToClone - 1) {
          // We're in the prepended clones, jump to the end
          track.style.transition = 'none';
          currentIndex = totalItems + itemsToClone - 1;
          updateCarousel();
          setTimeout(() => {
            track.style.transition = 'transform 0.5s ease';
            isTransitioning = false;
          }, 50);
        } else if (currentIndex >= totalItems + itemsToClone) {
          // We're in the appended clones, jump to the start
          track.style.transition = 'none';
          currentIndex = itemsToClone;
          updateCarousel();
          setTimeout(() => {
            track.style.transition = 'transform 0.5s ease';
            isTransitioning = false;
          }, 50);
        } else {
          isTransitioning = false;
        }
      }, 500);
    }

    window.moveCarousel = moveCarousel;

    function goToSlide(index) {
      if (isTransitioning) return;

      const itemsToClone = Math.max(itemsPerView, 2);
      currentIndex = index + itemsToClone;
      updateCarousel();
    }

    window.addEventListener('resize', () => {
      updateItemsPerView();
      createIndicators();
      setupInfiniteLoop();
    });

    // Initialize
    updateItemsPerView();
    createIndicators();
    setupInfiniteLoop();

    // Auto-play carousel
    //setInterval(() => {
    //    moveCarousel(1);
    //}, 5000);


  } catch(e) { console.error(e); }
})();
})();
